import {
  addCachedImpression,
  getCachedImpressionKeys,
} from './cachedImpressionKeys'

const dismissedTreatments = new Set(['control', 'ineligible'])
const experimentEnrollmentSplits = new Set(['publish-revamp'])

// Gate impression tracking until feature flip attributes are loaded.
// Without this, the SDK evaluates with empty attributes on first render,
// producing incorrect treatments and spurious "Experiment Enrolled" events.
let attributesReady = false

export function setImpressionTrackingReady(ready: boolean): void {
  attributesReady = ready
}

export default function trackImpression({
  impression,
}: SplitIO.ImpressionData) {
  if (!attributesReady) {
    return
  }

  // don't track control treatments, usually means sdk not ready
  if (dismissedTreatments.has(impression.treatment)) {
    return
  }
  // Should be an org id, so 'key' means SDK is not ready yet
  if (impression.keyName === 'key') {
    return
  }

  // Cache an 'impression' so we don't track the same evaluation more than once for
  // a single page session
  const impressionKey = `${impression.feature}-${impression.keyName}-${impression.treatment}`
  if (!getCachedImpressionKeys().includes(impressionKey)) {
    addCachedImpression(impressionKey)

    // We need Segment :)
    if (!window.analytics) {
      return
    }

    // Track this as an experiment enrolled if the feature in question starts
    // with 'eid' or 'geid', or if it is explicitly allowlisted.
    const featureName = impression.feature.toLowerCase()
    if (
      featureName.startsWith('geid') ||
      featureName.startsWith('eid') ||
      experimentEnrollmentSplits.has(featureName)
    ) {
      window.analytics.track('Experiment Enrolled', {
        experimentId: impression.feature,
        experimentGroup: impression.treatment,
        product: 'buffer',
        sourceFramework: 'split',
        view: window.location.href,
        organizationId: impression.keyName,
      })
    }
  }
}
